import { DeliveryModes, PractitionerTypes, FacilityTypes } from './schema'

export const specialistServices = [
  {
    serviceId: 'SPEC_001',
    serviceName: 'Cardiology Consultation',
    category: 'Specialist Services',
    specialty: 'Cardiology',
    subCategory: 'Heart Health',
    description: 'Specialized consultation for cardiovascular conditions',
    cost: 850,
    durationMinutes: 45,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.VIRTUAL],
    requiredPractitionerType: PractitionerTypes.SPECIALIST,
    status: 'active',
    billingCode: 'SPEC_CARDIO',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.HOSPITAL],
    customisable: true,
    tags: ['cardiology', 'heart', 'specialist'],
    displayOrder: 1
  },
  {
    serviceId: 'SPEC_002',
    serviceName: 'Dermatology Consultation',
    category: 'Specialist Services',
    specialty: 'Dermatology',
    subCategory: 'Skin Health',
    description: 'Specialized consultation for skin, hair, and nail conditions',
    cost: 750,
    durationMinutes: 30,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.VIRTUAL],
    requiredPractitionerType: PractitionerTypes.SPECIALIST,
    status: 'active',
    billingCode: 'SPEC_DERMA',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.HOSPITAL],
    customisable: true,
    tags: ['dermatology', 'skin', 'specialist'],
    displayOrder: 2
  },
  {
    serviceId: 'SPEC_003',
    serviceName: 'Orthopedic Consultation',
    category: 'Specialist Services',
    specialty: 'Orthopedics',
    subCategory: 'Bone and Joint Health',
    description: 'Specialized consultation for bone, joint, and muscle conditions',
    cost: 900,
    durationMinutes: 45,
    deliveryModes: [DeliveryModes.IN_PERSON],
    requiredPractitionerType: PractitionerTypes.SPECIALIST,
    status: 'active',
    billingCode: 'SPEC_ORTHO',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.HOSPITAL],
    customisable: true,
    tags: ['orthopedics', 'bone', 'joint'],
    displayOrder: 3
  },
  {
    serviceId: 'SPEC_004',
    serviceName: 'Gynecology Consultation',
    category: 'Specialist Services',
    specialty: 'Gynecology',
    subCategory: "Women's Health",
    description: "Specialized consultation for women's reproductive health",
    cost: 800,
    durationMinutes: 40,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.VIRTUAL],
    requiredPractitionerType: PractitionerTypes.SPECIALIST,
    status: 'active',
    billingCode: 'SPEC_GYNECO',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.HOSPITAL],
    customisable: true,
    tags: ['gynecology', "women's health", 'reproductive'],
    displayOrder: 4
  },
  {
    serviceId: 'SPEC_005',
    serviceName: 'Ophthalmology Consultation',
    category: 'Specialist Services',
    specialty: 'Ophthalmology',
    subCategory: 'Eye Health',
    description: 'Specialized consultation for eye and vision conditions',
    cost: 700,
    durationMinutes: 35,
    deliveryModes: [DeliveryModes.IN_PERSON],
    requiredPractitionerType: PractitionerTypes.SPECIALIST,
    status: 'active',
    billingCode: 'SPEC_OPHTHAL',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.HOSPITAL],
    customisable: true,
    tags: ['ophthalmology', 'eye', 'vision'],
    displayOrder: 5
  },
  {
    serviceId: 'SPEC_006',
    serviceName: 'Psychiatry Consultation',
    category: 'Specialist Services',
    specialty: 'Psychiatry',
    subCategory: 'Mental Health',
    description: 'Specialized consultation for mental health and psychiatric conditions',
    cost: 950,
    durationMinutes: 60,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.VIRTUAL],
    requiredPractitionerType: PractitionerTypes.SPECIALIST,
    status: 'active',
    billingCode: 'SPEC_PSYCH',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.HOSPITAL, FacilityTypes.WELLNESS_CENTER],
    customisable: true,
    tags: ['psychiatry', 'mental health', 'specialist'],
    displayOrder: 6
  }
]

export default specialistServices
